// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"7a6727f8","96":"a4fe8a4e","150":"a232248b","198":"aaac65a9","263":"2083cd3d","522":"1b1a8544","679":"bab9537a","732":"ccf1f4dd","952":"90b2a6bf","958":"047e96a6","975":"326bd7f9"}[chunkId] + ".chunk.js";
};